import '../../styles/common/header.scss';

import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';

import ImgLogo from '@/assets/images/common/admin_logo_gray.svg';

function PublicHeader(): JSX.Element {
  const params = useParams<{ matchbox_id: string }>();
  const matchboxId = useMemo(() => params.matchbox_id, [params]);
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <Link to="/admin/search">
            <img src={ImgLogo} alt="" />
          </Link>
        </div>
        <nav>
          <ul>
            <li className="opacity-30 pointer-events-none">
              <a href="/mypage">ホーム</a>
            </li>
            <li className="opacity-30 pointer-events-none">
              <a href="/mypage/portfolio/edit">ポートフォリオ</a>
            </li>
            <li>
              <a href={`/admin/transcription/${matchboxId}/resume/edit`}>履歴書</a>
            </li>
            <li>
              <a href={`/admin/transcription/${matchboxId}/cv/edit`}>職務経歴書</a>
            </li>
          </ul>
          <div className="profile_icon mkt_mask_items opacity-30 pointer-events-none">
            <img src="/images/components/other_components/Circle-placeholder.png" alt="" />
          </div>
        </nav>
      </div>
    </header>
  );
}

export default PublicHeader;
